import { render, staticRenderFns } from "./entityManagement.vue?vue&type=template&id=2f279124&scoped=true"
import script from "./entityManagement.vue?vue&type=script&lang=js"
export * from "./entityManagement.vue?vue&type=script&lang=js"
import style0 from "./entityManagement.vue?vue&type=style&index=0&id=2f279124&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f279124",
  null
  
)

export default component.exports